import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminBoardService from '../../service/AdminBoardService';
import Button from '../atom/Button';

const AdminVocLoginPage = () => {
  const [AdminPassword, setAdiminPassword] = useState<string>('');
  const [flag, setFlag] = useState<boolean>(false);

  const page = 0;
  const size = 15;
  const accept = '4';
  const navigate = useNavigate();

  const handleLoginAdminChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value);
    setAdiminPassword(e.target.value);
  };

  const activeEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleLoginAdiminSubmit();
    }
  };

  useEffect(() => {
    if (flag) {
      moveBoardPage();
    }
  }, [flag]);

  const handleLoginAdiminSubmit = async () => {
    const responseAssign = await AdminBoardService.getAssignVoc();
    const dataList = await responseAssign.data; //조치담당자 호출

    localStorage.setItem('assingPersonList', JSON.stringify(dataList));

    const response = await AdminBoardService.getVocBoardList({
      page,
      size,
      adminPassword: AdminPassword,
      progress: accept
    });
    // console.log(response);
    if (response.status === 'success') {
      sessionStorage.setItem('isAdmin', 'true');
      sessionStorage.setItem('pw', `${AdminPassword}`);
      setFlag(true);
    } else {
      alert('로그인 실패');
    }
  };

  const moveBoardPage = () => {
    navigate('/AdminVocBoard');
  };
  console.log(process.env.REACT_APP_SERVER_URL);
  return (
    <div className="loginPage">
      <div className="loginBox">
        <div className="adminHeader">
          <h1>관리자통합게시판</h1>
          <p className="sub">관리자 전용 로그인</p>
        </div>

        <div className="inputBoxStyle">
          <form
            onSubmit={e => {
              e.preventDefault();
              handleLoginAdiminSubmit();
            }}
          >
            <label className="label">
              <span>비밀번호</span>
              <input
                onChange={handleLoginAdminChange}
                onKeyDown={e => activeEnter(e)}
                type="password"
                placeholder="패스워드를 입력해주세요."
                autoFocus
              />
            </label>

            <div className="loginBtn">
              <Button
                text={'로그인'}
                backgroundColor={'#0066cc'}
                fontColor={'#ffffff'}
                borderRadius={'6px'}
                width={'100%'}
                type={'submit'}
                onClick={handleLoginAdiminSubmit}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminVocLoginPage;
